import { deleteOfficeBrands } from "../../../../../actions/Utilities/OfficeBrand";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeleteOfficeBrand = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteOfficeBrands(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetOfficeBrands"]);
      toast.fire(
        "Success",
        "Office Brand has been deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Failed",
        "Server Error: Cannot deactivate Office Brands",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteOfficeBrand;
